import { render } from "./admin-stall.vue?vue&type=template&id=2fb91e09&scoped=true"
import script from "./admin-stall.vue?vue&type=script&lang=js"
export * from "./admin-stall.vue?vue&type=script&lang=js"

import "./admin-stall.vue?vue&type=style&index=0&id=2fb91e09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb91e09"]])

export default __exports__